/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const ConnectStepMessages = defineMessages({
  title: {
    id: 'Segment.ConnectStepMessages.title',
    defaultMessage: 'Connect Segment to your assistant'
  },
  stepOne: {
    id: 'Segment.ConnectStepMessages.stepOne',
    defaultMessage:
      'Create a new Segment account or log in to an {ExistingAccountLink}.'
  },
  stepOneLink: {
    id: 'Segment.ConnectStepMessages.stepOneLink',
    defaultMessage: 'existing account'
  },
  stepTwo: {
    id: 'Segment.ConnectStepMessages.stepTwo',
    defaultMessage:
      'Once you have created your account, connect IBM Watson as a source and follow the steps to retrieve a Segment key. Copy and paste this key here to form a secure connection between Segment and IBM Watson.'
  },
  signUpAccount: {
    id: 'Segment.ConnectStepMessages.signUpAccount',
    defaultMessage: 'Sign up for a free account'
  },
  connect: {
    id: 'Segment.ConnectStepMessages.connect',
    defaultMessage: 'Connect'
  },
  required: {
    id: 'Segment.ConnectStepMessages.required',
    defaultMessage: 'Segment write key is required'
  },
  invalidKey: {
    id: 'Segment.ConnectStepMessages.invalidKey',
    defaultMessage: 'Invalid write key'
  },
  navigateToSegment: {
    id: 'Segment.ConnectStepMessages.navigateToSegment',
    defaultMessage: 'Navigate to your '
  },
  segmentWorkspace: {
    id: 'Segment.ConnectStepMessages.segmentWorkspace',
    defaultMessage: 'Segment workspace.'
  },
  tooltip: {
    id: 'Segment.ConnectStepMessages.tooltip',
    defaultMessage:
      "If you're a new Segment user, ask your admin to add you to the appropriate Segment workspace."
  },
  videoDescription: {
    id: 'Segment.ConnectStepMessages.videoDescription',
    defaultMessage: 'See our documentation on '
  },
  videoDescriptionLink: {
    id: 'Segment.ConnectStepMessages.videoDescriptionLink',
    defaultMessage: 'How to set up your Segment Integration'
  }
});
